// open small window which clicking on twitter share page button
const tweetPageLink = document.querySelector("#toolbarActions a.twitter");
if (tweetPageLink) {
    tweetPageLink.addEventListener("click", function(event) {
        event.preventDefault();
        window.open(this.href, "name", "height=300,width=450");
    });
}